/**
 * WebAPI(Ajax通信)のレスポンスエンティティ群
 * */

/**
 * WebAPI(Ajax通信)の大外のレスポンスエンティティ
 * "resData"にWebAPIの処理結果(検索結果など)が詰め込まれてくる想定です。
 */
export class responseEntity {
	/**
	 * WebAPIの処理結果
	 */
	public result: resultEntity;
	/**
	 *　WebAPIの出力値
	 */
	public data: any;
}

/**
 * WebAPIの処理結果
 */
export class resultEntity {
	/**
	 * WebAPI側の処理結果
	 */
	public code: number;
	/**
	 * エラーメッセージ
	 */
	public message: string;
}

